import { render, staticRenderFns } from "./AdApprovalResultField.vue?vue&type=template&id=aebf4dd6&scoped=true&"
import script from "./AdApprovalResultField.vue?vue&type=script&lang=js&"
export * from "./AdApprovalResultField.vue?vue&type=script&lang=js&"
import style0 from "./AdApprovalResultField.vue?vue&type=style&index=0&id=aebf4dd6&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aebf4dd6",
  null
  
)

export default component.exports